import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { Container, Grid, styled } from "@mui/material";

import { getEmployeeProfile } from "../../../../../actions/employee";
import { getUserProfile } from "../../../../../actions/user";

import LeftPanel from "./left";
import RightPanel from "./right";

const StyledRoot = styled("div")({
  backgroundColor: "#FFFFFF !important",
});

const EmployeeProfilePage = (props) => {
  const dispatch = useDispatch();
  const { user: currentUser } = useSelector((state) => state.auth);
  const { result: userProfile } = useSelector((state) => state.userProfile);
  let { id } = useParams();

  useEffect(() => {
    if (currentUser) {
      dispatch(getUserProfile(currentUser.id));
    }
  }, []);

  useEffect(() => {
    if (userProfile) {
      dispatch(getEmployeeProfile(userProfile.idCompany, id));
    }
  }, [userProfile]);

  return (
    <StyledRoot className={`page`}>
      {/* <StyledCover /> */}
      <Container maxWidth="lg">
        <Grid container spacing={2}>
          <Grid item xs={12} sm={4}>
            <LeftPanel />
          </Grid>
          <Grid item xs={12} sm={8}>
            <RightPanel />
          </Grid>
        </Grid>
      </Container>
    </StyledRoot>
  );
};

export default EmployeeProfilePage;
